class AppGlobalStore {
    globalStore = null;

    setGlobalStore = (store) => {
        this.globalStore = store;
    };

    getGlobalStore = () => {
        return this.globalStore;
    };

    reduceStore = (storeReducer) => {
        if (typeof storeReducer === "function") {
            return storeReducer(this.getGlobalStore().getState());
        }
        throw Error("StoreReducer is not a function");
    };
}
export default new AppGlobalStore();
